<template>
  <div class="c-confirmation-content text-size-4 line-height-6 mt--2 mb--4">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.c-confirmation-content {
  letter-spacing: 0.5px;
}
</style>
